<template>
  <div id="otherIncome-edit" class="group-setup">
    <v-progress-linear
      indeterminate
      color="blue"
      v-if="loading"
    ></v-progress-linear>

    <v-layout row v-if="errors">
      <v-flex>
        <Alert @dismissed="onDismissed" :text="errors"></Alert>
      </v-flex>
    </v-layout>

    <v-form v-if="!loading">
      <v-row>
        <v-col cols="12" md="12" sm="12">
          <v-card class="pa-5" flat>
            <HeaderDividerBlock
              headerText="Edit Other Income"
            ></HeaderDividerBlock>
            <v-row>
              <v-col cols="6" sm="6">
                <v-col class="pa-0 ma-0">
                  <p class="text-title">Income Type Name</p>
                </v-col>
                <v-text-field
                  outlined
                  dense
                  v-model="form.name"
                  required
                  clearable
                  placeholder="Name"
                ></v-text-field>
              </v-col>

              <v-col cols="6" sm="6">
                <v-col class="pa-0 ma-0">
                  <p class="text-title">Description</p>
                </v-col>
                <v-text-field
                  outlined
                  dense
                  v-model="form.description"
                  required
                  clearable
                  placeholder="Description"
                ></v-text-field>
              </v-col>

              <v-col cols="6" sm="6">
                <v-col class="pa-0 ma-0">
                  <p class="text-title">Associated GL Account</p>
                </v-col>
                <v-autocomplete
                  outlined
                  dense
                  v-model="form.gl_account_id"
                  required
                  clearable
                  placeholder="GL Account"
                  :items="IncomeAccounts"
                  item-text="title"
                  item-value="id"
                ></v-autocomplete>
              </v-col>
            </v-row>

            <v-col cols="6" sm="6">
              <v-col class="pa-0 ma-0">
                <p class="text-title">Tax Applicability</p>
              </v-col>
              <v-select
                outlined
                dense
                v-model="form.tax_applicable"
                :items="['GST', 'VAT', 'None']"
                required
                clearable
                placeholder="Select Tax Applicability"
              ></v-select>
            </v-col>

            <v-card-actions class="mt-10">
              <v-row>
                <v-col cols="12" md="10" xs="6"></v-col>
                <v-col cols="12" md="2" xs="6">
                  <v-btn
                    v-if="hasPermission('other_income_types.edit')"
                    large
                    color="#00B3FF"
                    dark
                    depressed
                    block
                    @click="submit"
                  >
                    Save Changes
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-form>

    <Snackbars
      :text="succesMsg"
      :snackbar="snackbar"
      :color="'success'"
      @classSnackbar="clossSnackbar"
    />
  </div>
</template>

<script>
import Alert from "@/components/shared/Alert";
import Snackbars from "@/components/shared/Snackbars";
import HeaderDividerBlock from "@/components/shared/HeaderDividerBlock";
import { OtherIncomeService } from "@/services/otherIncome-service.js";
import { checkError } from "@/config/errors.js";
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");

export default {
  name: "EditOtherIncome",
  components: {
    Alert,
    Snackbars,
    HeaderDividerBlock,
  },
  data() {
    return {
      loading: false,
      errors: null,
      snackbar: false,
      succesMsg: "",
      form: {
        name: "",
        description: "",
        gl_account_id: "",
        tax_applicable: "",
      },
      IncomeAccounts: [],
    };
  },

  computed: {
    ...mapGetters({
      hasPermission: "hasPermission",
    }),
  },

  created() {
    this.fetchGlAccounts();
    this.fetchIncomeType();
  },

  methods: {
    async fetchIncomeType() {
      this.loading = true;
      try {
        const response = await OtherIncomeService.getIncomeTypeByUuid(
          this.$route.params.uuid
        );

        if (response) {
          const Data = response;
          this.form.name = Data.name;
          this.form.description = Data.description;
          this.form.gl_account_id = Data.gl_account_id;
          this.form.tax_applicable = Data.tax_applicable;
        }

        console.log("this.form : ", this.form.name);
      } catch (error) {
        console.error(error);
        let data = error.response.data;
        let errorOutput = checkError.errorFormatting(data);
        this.errors = errorOutput;
      } finally {
        this.loading = false;
      }
    },

    async submit() {
      this.loading = true;
      this.errors = null;
      try {
        const incomeTypeId = this.$route.params.uuid;
        const response = await OtherIncomeService.updateOtherIncome(
          incomeTypeId,
          this.form
        );
        this.succesMsg = response.message;
        this.snackbar = true;
      } catch (error) {
        console.error(error);
        let data = error.response.data;
        let errorOutput = checkError.errorFormatting(data);
        this.errors = errorOutput;
      } finally {
        this.loading = false;
      }
    },

    async fetchGlAccounts() {
      try {
        const incomeAccounts = await OtherIncomeService.getIncomeAccounts();
        this.IncomeAccounts = incomeAccounts;
      } catch (error) {
        console.error(error);
        let data = error.response.data;
        let errorOutput = checkError.errorFormatting(data);
        this.errors = errorOutput;
      }
    },
  },
};
</script>
